import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('surveys', 'forms');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'assigned_forms',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/surveys/forms.js